// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { myListsDetailsOptionsStyles } from "@awc/Overrides/Widgets/MyListsDetails/MyListsDetailsOptions";
import { styledShadowBoxStyle } from "@awc/XDL/Components/Common/ShadowBox";
import Search from "@awc/XDL/Icons/Search";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color, createLinkIconStyles, hideElementOnPrint, xScreen } from "@awc/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import ChevronsUpDown from "@insite/mobius/Icons/ChevronsUpDown";
import ShoppingCart from "@insite/mobius/Icons/ShoppingCart";
import X from "@insite/mobius/Icons/X";
import { PaginationStyle } from "@insite/mobius/Pagination";
import { css } from "styled-components";

myListsDetailsOptionsStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;

        margin-bottom: 10px;
        ${hideElementOnPrint}
    `,
};

myListsDetailsOptionsStyles.topSectionWrapper = {
    css: css`
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
        ${xScreen("lte", "md")} {
            gap: 10px;
            flex-direction: column;
        }
    `,
};

myListsDetailsOptionsStyles.bottomSectionWrapper = {
    css: css`
        display: flex;
        column-gap: 22px;
        row-gap: 12px;
        width: 100%;
        border-top: 1px solid ${color("common.border")};
        padding-top: 10px;
        ${xScreen("lte", "md")} {
            gap: 16px;
            flex-direction: column;
        }
        ${PaginationStyle} {
            margin: 0;
        }
    `,
};

myListsDetailsOptionsStyles.leftSectionWrapper = {
    css: css`
        display: flex;
        flex-basis: 41.66%;
        gap: 16px;
        align-items: center;
        ${xScreen("lte", "md")} {
            flex-basis: 100%;
        }
        ${xScreen("lte", "md")} {
            flex-direction: column;
            & > div {
                width: 100%;
            }
        }
    `,
};

myListsDetailsOptionsStyles.addDeleteWrapper = {
    css: css`
        display: flex;
        gap: 8px;
        ${xScreen("lte", "md")} {
            flex-direction: column;
            flex: 1;
        }
    `,
};

myListsDetailsOptionsStyles.rightSectionWrapper = {
    css: css`
        display: flex;
        align-items: flex-end;
        column-gap: 10px;
        align-items: center;
        flex-grow: 1;
        & > ${PaginationStyle} {
            margin-left: auto;
            gap: 40px;
            ${xScreen("lte", "sm")} {
                flex: 1;
                margin-top: 10px;
                gap: 20px;
            }
        }
        ${xScreen("lte", "sm")} {
            flex-wrap: wrap;
        }
        ${styledShadowBoxStyle}
    `,
};

myListsDetailsOptionsStyles.editSortOrderLink = {
    css: css`
        ${xScreen("lte", "sm")} {
            margin-top: 10px;
        }
    `,
};

myListsDetailsOptionsStyles.search = {
    sizeVariant: "small",
    iconProps: {
        src: Search,
        size: 16,
    },
    cssOverrides: {
        formInputWrapper: css`
            ${IconWrapper} {
                top: 1px;
            }
        `,
        formField: css`
            width: auto;
            min-width: 270px;
        `,
        inputSelect: css`
            padding: 0 24px 0 28px;
            &:focus {
                padding: 0 24px 0 28px;
            }
        `,
    },
    leftAlignIcon: true,
};

myListsDetailsOptionsStyles.innerButtonWrapper = {
    css: css`
        display: flex;
        gap: 8px;
        ${xScreen("lte", "md")} {
            width: 100%;

            justify-content: end;
            flex-direction: column;
            button {
                width: 100%;
            }
        }
    `,
};

myListsDetailsOptionsStyles.sortBySelect = {
    mergeCss: true,
    sizeVariant: "small",
    cssOverrides: {
        formField: css`
            width: auto;
        `,
    },
};

myListsDetailsOptionsStyles.editSortOrder = {
    css: css`
        cursor: pointer;
    `,
};

myListsDetailsOptionsStyles.addSelectedToCartButton = myListsDetailsOptionsStyles.deleteSelectedButton = {
    sizeVariant: "large",
    css: css`
        height: fit-content;
    `,
};

myListsDetailsOptionsStyles.listInfoWrapper = {
    css: css`
        display: flex;
        gap: 15px;
        align-items: baseline;
        ${xScreen("lte", "md")} {
            width: 100%;
        }
        ${xScreen("lte", "sm")} {
            flex-direction: column;
            gap: 5px;
        }
    `,
};

myListsDetailsOptionsStyles.wishlistLabel = myListsDetailsOptionsStyles.wishlistCount = {
    size: fontConfig.fontSize.singleLineRegular,
    lineHeight: fontConfig.lineHeight.regular,
    weight: fontConfig.weight.bold,
};

myListsDetailsOptionsStyles.addListButton = {
    variant: "secondary",
    css: css`
        width: fit-content;
        padding: 0 15px;
        white-space: nowrap;
    `,
};

myListsDetailsOptionsStyles.itemsTotalWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 15px;
    `,
};
